// src/components/AdminTabPICAgeGroup.js
import React, { useEffect, useState } from "react";
import TabTwoColumnLayout from "../layouts/TabTwoColumnLayout";
import AdminListItem from "../components/AdminListItem";
import { apiFetch } from "../utils/wkCommon";

export default function AdminTabPICAgeGroup() {
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState(null);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let mounted = true;
    (async () => {
      setLoading(true);
      try {
        const resp = await apiFetch("/api/category-age-groups?populate=PIC_AgeGroup&sort=AgeRangeMaximum:desc");
        if (!mounted) return;
        setItems(resp?.data || []);
      } catch (e) {
        console.error(e);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => (mounted = false);
  }, []);

  const filtered = items.filter(it => {
    const a = it.attributes || it;
    const text = `${a.FlagField || ""} ${a.name || ""}`.toLowerCase();
    return text.includes(q.toLowerCase());
  });

  const leftControls = (
    <>
      <input placeholder="Search name/flag..." value={q} onChange={e => setQ(e.target.value)} />
      <button>+ New</button>
    </>
  );

  const leftList = (
    <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
      {loading ? <li>Loading…</li> : filtered.map(it => {
        const a = it.attributes || it;
        const title = a.name;
        const subtitle = `${a.FlagField || ""} ${a.AgeRangeMinimum != null ? `— ${a.AgeRangeMinimum}` : ""}${a.AgeRangeMaximum != null ? `–${a.AgeRangeMaximum}` : ""}`;
        return <AdminListItem key={it.id} title={title} subtitle={subtitle} onClick={() => setSelected(it)} active={selected?.id === it.id} />;
      })}
    </ul>
  );

  const rightForm = selected ? <div>{selected.attributes?.name}</div> : <div>Pilih Age Group dari kiri.</div>;

  return <TabTwoColumnLayout leftControls={leftControls} leftList={leftList} rightForm={rightForm} />;
}
